import React from 'react';

interface DefaultDropdownItemProps {
  text: string;
  subtext?: string;

  leading?: React.ReactNode;
  trailing?: React.ReactNode;
}

export default function DefaultDropdownItem({ text, subtext, leading, trailing }: DefaultDropdownItemProps) {
  return (
    <div className='flex gap-2'>
      {leading && leading}
      <div className='flex-grow overflow-hidden'>
        <p>{text}</p>
        {subtext && <p className='text-xs'>{subtext}</p>}
      </div>
      {trailing && trailing}
    </div>
  );
}
